module.exports = __webpack_public_path__ + "static/media/4kvideo.75c7f829.mp4";